export enum OrderType {
    DEFAULT = "default",
    PRICE_ASC = "priceASC",
    PRICE_DESC = "priceDESC",
}

export enum OrderDirection {
    ASC = "asc",
    DESC = "desc"
}

export interface IOrderConfig {
    name: string;
    field: string;
    direction: OrderDirection;
}

export type IOrderConfigCollection = {
    [index in OrderType]: IOrderConfig;
};

export const ORDER_CONFIG: IOrderConfigCollection = {
    [OrderType.DEFAULT]: {field: "default", direction: OrderDirection.DESC, name: "Default"},
    [OrderType.PRICE_ASC]: {field: "price", direction: OrderDirection.ASC, name: "price ASC"},
    [OrderType.PRICE_DESC]: {field: "price", direction: OrderDirection.DESC, name: "price DESC"},
};
